var cache = {};
var _updateCache = function (state, chatroomId) {
    var cachedValue = cache[chatroomId];
    var shouldUpdate = cachedValue === undefined && state[chatroomId] !== undefined;
    if (shouldUpdate) {
        cache[chatroomId] = state[chatroomId];
    }
    return shouldUpdate;
};
var _getFromCache = function (chatroomId, wasUpdated) {
    return { value: cache[chatroomId], dontUpdate: !wasUpdated };
};
export var get = function (state, chatroomId) {
    var wasUpdated = _updateCache(state, chatroomId);
    return _getFromCache(chatroomId, wasUpdated);
};
export var invalidate = function (chatroomId) { return delete cache[chatroomId]; };
export var invalidateAll = function () { return cache = {}; };
